import Vue from "vue";
import ContentElement from "../models/contentManagement/contentElement";
import routes from "../../formability/listViewBuilder/routes/routes";
import {BuilderArea} from "../../formability/listViewBuilder/enums/builder-area";
import ElementHandler from "~/services/elementHandler";
import {certificateElementType} from "~/enums/certificateElementType";
import AdaptiveLayoutSection from "../../formability/certificateBuilder/models/adaptiveLayoutSection";

export default class AdaptiveLayoutSectionHandler extends ElementHandler {


  append(type: number | string, position: number = null, json: object = {}): AdaptiveLayoutSection {
    position = position === 0 || !!position ? position : this.positionValueIfNonePassedIn + 1
    const element = super.append(type, position, json);
    this.updateElementPositions(this.model, element, position)
    return element
  }

  //If a control panel section is dragged within another section all elements below the point it is dragged are moved
  // to the new section per: https://www.pivotaltracker.com/story/show/176199289
  appendWithinSection(type: number | string, position: number = null, positionWithinSection: number = null){
    position = position === 0 || !!position ? position : this.positionValueIfNonePassedIn
    positionWithinSection = positionWithinSection === 0 || !!positionWithinSection ? positionWithinSection : this.positionWithinSectionValueIfNonePassedIn
    const sectionDraggedOver = this.model.adaptiveLayoutSectionsArray[position]
    const newSection = this.append(type, position  + 1)
    let newSectionElementIndex = 0
    for (let i = positionWithinSection; i < sectionDraggedOver.certificateElementsArray.length; i++) {
      const movedElement = sectionDraggedOver.certificateElementsArray[i]
      newSection.certificateElementHandler.move(movedElement.client_id, newSection.client_id, newSectionElementIndex++)
    }
    return newSection
  }

  create(parent, type: number | string, position: number, json: object = {}, selectItem: boolean = true) {
    json['sort_order'] = position;
    json['type'] = type;
    const element: ContentElement = this.model.rootModel.createEmbeddedObject[this.collectionKey](this, json);
    element.initialize(this.model.rootModel, parent, type, json);
    element.initializeAfterParentSet();
    if (typeof this.model.initializeEmbedded === 'function') {
      this.model.initializeEmbedded(parent, element, position, json, selectItem);
    }
    Vue.set(parent[this.collectionKey], element.client_id, element);
    if (!element.hasChanged) {
      // only track create specially if changes haven't already been made through initializing
      parent.trackCreationDeletion(element.client_id, null, element.asJson(), element);
    }
    this.model.rootModel.saveChangesToStore({
      modelId: element.client_id,
      area: routes.find(r => r.name === BuilderArea.layout).path + `?selectedId=${element.client_id}`
    });
    Vue.nextTick(() => {
      element.select()
    })
    return element;
  }


  createForParentId(parentId: string, type: number | string, position: number, json: object = {}) {
    const parent = this.model.rootModel.findInPropOfType(this.collectionArrayKey, this.containerClass, parentId);
    const element = this.create(parent, type, position, json);
    element.repo.add(element);
    element.select();
    return element;
  }

  //Called in the case of an element being clicked rather than dragged and dropped
  protected get positionWithinSectionValueIfNonePassedIn(): number{
    //Either is added after the selected layout element or after section
    return this.model.rootModel.selectedElementsLayoutElement?.sort_order === 0 || !!this.model.rootModel.selectedElementsLayoutElement?.sort_order ? this.model.rootModel.selectedElementsLayoutElement?.sort_order  :  this.model.certificateElementsArray.length
  }
  //Called in the case of an element being clicked rather than dragged and dropped
  protected get positionValueIfNonePassedIn(): number{
    //Either is added after the selected section/section that contains selected element or at the end of the array
    return this.model.selectedElementsSection?.sort_order === 0 || !!this.model.selectedElementsSection?.sort_order ?  this.model.selectedElementsSection?.sort_order : this.model.adaptiveLayoutSectionsArray.length
  }
}